import Search from './index.vue'
export default [{
    path: '/adwordsSearch',
    name:'adwordsSearch',
    component:Search,
},
{
    path: '',
    redirect: { name: 'adwordsSearch' }
}]